import React, { createContext, useContext, useEffect, useState } from "react";
import { authApi } from "../lib/api";

const AuthContext = createContext(null);

export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_70922d4e-b3fc-45bc-ac21-d6e220844f61/artifacts/6gnspary_logox3.png";

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [config, setConfig] = useState({
        allowed_domains: [],
        magic_link_enabled: false,
    });
    const [loading, setLoading] = useState(true);

    const refresh = async () => {
        try {
            const me = await authApi.me();
            setUser(me);
            return me;
        } catch {
            setUser(null);
            return null;
        }
    };

    useEffect(() => {
        (async () => {
            try {
                const cfg = await authApi.config();
                setConfig(cfg);
            } catch {
                // ignore
            }
            await refresh();
            setLoading(false);
        })();
    }, []);

    const loginWithPassword = async (email, password) => {
        const res = await authApi.login(email, password);
        setUser(res.user);
        return res.user;
    };

    const logout = async () => {
        await authApi.logout();
        setUser(null);
    };

    return (
        <AuthContext.Provider
            value={{
                user,
                config,
                loading,
                refresh,
                loginWithPassword,
                logout,
                setUser,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
